import { ADLNeedsQuestionnaireItem } from '../sections/adlNeeds/questionnaire'
import { AssessmentOverviewQuestionnaireItem } from '../sections/assessmentOverview/questionnaire'
import { CertPeriodRecapQuestionnaireItem } from '../sections/certPeriodRecap/questionnaire'
import { DischargePlanningQuestionnaireItem } from '../sections/dischargePlanning/questionnaire'
import { AuthorizationQuestionnaireItem } from '../sections/authorization/questionnaire'
import { PlanOfCareQuestionnaireItem } from '../sections/planOfCare/questionnaire'
import { VitalsQuestionnaireItem } from '../sections/vitals/questionnaire'
import { SupervisoryReviewQuestionnaireItem } from '../sections/supervisoryReview/questionnaire'
import { VisitSchedulingQuestionnaireItem } from '../sections/visitScheduling/questionnaire'
import { MedicationsQuestionnaireItem } from '../sections/medications/questionnaire'
import { MedicalBackgroundQuestionnaireItem } from '../sections/medicalBackground/questionnaire'
import { NarrativeQuestionnaireItem } from '../sections/narrative/questionnaire'
import { FinalStepsQuestionnaireItem } from '../sections/finalSteps/questionnaire'
import { SkilledNeedsQuestionnaireItem } from '../sections/skilledNeeds/questionnaire'

export const RecertAssessmentQuestionnaireItem = {
  ...AssessmentOverviewQuestionnaireItem,
  ...CertPeriodRecapQuestionnaireItem,
  ...ADLNeedsQuestionnaireItem,
  ...SkilledNeedsQuestionnaireItem,
  ...DischargePlanningQuestionnaireItem,
  ...AuthorizationQuestionnaireItem,
  ...PlanOfCareQuestionnaireItem,
  ...VisitSchedulingQuestionnaireItem,
  ...MedicationsQuestionnaireItem,
  ...VitalsQuestionnaireItem,
  ...MedicalBackgroundQuestionnaireItem,
  ...SupervisoryReviewQuestionnaireItem,
  ...NarrativeQuestionnaireItem,
  ...FinalStepsQuestionnaireItem
}

export type RecertAssessmentQuestionnaireItem =
  (typeof RecertAssessmentQuestionnaireItem)[keyof typeof RecertAssessmentQuestionnaireItem]
